<ng-template [ngIf]="asset.expiryDate && (asset.assetExpiryDays || asset.assetExpiryDays === 0)">
  <ng-template [ngIf]="asset.assetExpiryDays < 0">
    <mat-icon
      [ngClass]="{ '!text-[#F01F1F]': [CustomClients.SEAT, CustomClients.VKB].includes(brandingKey) }"
      class="mat-error material-icons-outlined pr-6 text-[#1212128F] text-[1.4rem]"
      [matTooltip]="textExpiredOn + ' ' + (asset.expiryDate | spDateFormat: { plainDate: true, isSafe: true })"
      >warning_amber</mat-icon
    >
  </ng-template>
  <ng-template [ngIf]="asset.assetExpiryDays <= expiryAssetInDays && asset.assetExpiryDays > 0">
    <mat-icon
      [ngClass]="{ '!text-[#F01F1F]': [CustomClients.SEAT, CustomClients.VKB].includes(brandingKey) }"
      class="mat-error material-icons-outlined pr-6 text-[#1212128F] text-[1.4rem]"
      [matTooltip]="textWillExpireOn + ' ' + (asset.expiryDate | spDateFormat: { plainDate: true, isSafe: true }) + '.'"
      >warning_amber</mat-icon
    >
  </ng-template>
</ng-template>
